import settings from '@/../settings.json';

const FALLBACK_TOPDOMAIN = 'dev';

/**
 * Interface for how the application settings may be stored
 */
interface IAppSettings {
    ungroupedMappingWorkNo: string;
    fortnoxIntegrationAddress: string;
    fortnoxClientId: string;
    agGridKey: string;
    intercomAppId: string;
    intercomKey: string;
    analyticsKey: string;
    cookiebotId: string;
    enableTranslations: boolean;
    enableGtm: boolean;
    enableVersionCheck: boolean;
    startdeliverApiKey: string;
    enableStartdeliver: boolean;
    satismeterKey: string;
    enableSatismeter: boolean;
    enableSaltfish: boolean;
    saltfishKey: string;
    enableOpentelemetry: boolean;
    updateRefreshInterval: number;
}

// Load the settings to a variable
export const appSettings: IAppSettings = settings;

export function getTopDomain(): string {
    const host = window.location.host.split(':')[0];

    if (host === 'localhost') return FALLBACK_TOPDOMAIN;

    const parts = host.split('.');
    const topDomain = parts.pop();

    if (topDomain == null) return FALLBACK_TOPDOMAIN;
    return topDomain;
}

export function getApiHost(): string {
    return `sysarb.${getTopDomain()}/api`;
}
